export enum SnackbarPannelClass {
    Info = "snackbar-info",
    Error = "snackbar-error",
    Warn = "snackbar-warn",
    Success = "snackbar-success",
    Magenta = "snackbar-magenta"
}